import { resultTypes } from '@/application/services/utils/evaluations-utils';

export function getResult(ratio, offerValue) {
  if (ratio === 1) return resultTypes.APPROVED;
  if (!ratio) return resultTypes.WITHOUT_OFFER;
  if (offerValue && offerValue >= 500) return resultTypes.WITH_OFFER;
  return resultTypes.WITHOUT_OFFER;
}

export function getEvaluationResult(eligibility) {
  if (eligibility === 'Approved') return resultTypes.APPROVED;
  if (eligibility === 'Refused') return resultTypes.NOT_ELIGIBLE;
  return resultTypes.REVIEW;
}
